import { createSelector } from "reselect";
import get from "lodash/get";
import { forms } from "utils/constants";
import { userLoginOTPDomain } from "../requestOTP";

/**
 * Extracting Login OTP from values
 * @param {object} state
 */
const userLoginOtpDomain = state =>
  get(state, `form.${forms.USER_LOGIN_OTP_FORM}.values`, {});

const requestOTTDomain = state => get(state.api, "requestOtt.data", {});

const requestGuestOTTDomain = state =>
  get(state.api, "requestGuestOtt.data", {});

const guestRequestOTTDomain = state =>
  get(state.api, "requestGuestOtt.data", {});

const guestOttValidationDomain = state =>
  get(state.api, "validateGuestOtt.data", {});

const formsDomain = formName => state =>
  get(state, `form.${formName}.values`, {});

/**
 * ************ Login OTP Form Selectors ************
 */
export const isValidOTP = (fieldName = "current_otp", otpLength = 6) =>
  createSelector(userLoginOtpDomain, formValues => {
    const otpValuesArray = get(formValues, `${fieldName}`, [""]);

    if (otpValuesArray.length === otpLength) {
      return otpValuesArray.find(item => item === "") === undefined;
    } else {
      return false;
    }
  });

export const isValidOTTSelector = (
  formName,
  otpLength = 6,
  fieldName = "current_otp"
) =>
  createSelector(formsDomain(formName), formValues => {
    const otpValuesArray = get(formValues, `${fieldName}`, [""]);
    if (otpValuesArray.length === otpLength) {
      return otpValuesArray.find(item => item === "") === undefined;
    } else {
      return false;
    }
  });

/**
 * ************ Request OTT  Selectors ************
 */

export const requestOTT = createSelector(requestOTTDomain, ott =>
  get(ott, "requestId")
);

export const ottExpiresIn = createSelector(requestOTTDomain, ott =>
  get(ott, "expiresIn", 180)
);

/** Guest User OTT Flow */

export const guestRequestOTT = createSelector(guestRequestOTTDomain, ott =>
  get(ott, "requestId")
);

export const guestOttExpiresIn = createSelector(guestRequestOTTDomain, ott => {
  return get(ott, "expiresIn", 180);
});
export const guestOttResendAllowed = createSelector(
  guestRequestOTTDomain,
  ott => get(ott, "resendAllowed", true)
);
export const guestOttResendAllowedAfter = createSelector(
  guestRequestOTTDomain,
  ott => get(ott, "resendAllowedAfter", 240)
);

export const guestOttValidation = createSelector(
  guestOttValidationDomain,
  ott => get(ott, "accessToken", false) || get(ott, "requestId", false)
);

export const guestAccessToken = createSelector(
  guestOttValidationDomain,
  ott => get(ott, "accessToken", false) || get(ott, "requestId", false)
);

export const guestOttChannelsSelector = createSelector(
  requestGuestOTTDomain,
  guestOtt => get(guestOtt, "channels", {})
);

export const loginSignupOttpExpiresIn = createSelector(
  userLoginOTPDomain,
  ott => get(ott, "expiresIn", 180)
);

export const guestOttErrCode = createSelector(
  guestOttValidationDomain,
  ottValidatation =>
    get(
      ottValidatation,
      "response.failure.errorCode",
      "RESEND_SOMETHING_WENT_WRONG"
    )
);
/**
 * ************ Resend OTT  Selectors ************
 */
export const ottResendAllowed = createSelector(requestOTTDomain, ott =>
  get(ott, "resendAllowed", true)
);
export const ottResendAllowedAfter = createSelector(requestOTTDomain, ott =>
  get(ott, "resendAllowedAfter", 240)
);

/**
 * ************ Make Selectors ************
 */
export const makeSelectIsValidOTP = (fieldName, otpLength) =>
  isValidOTP(fieldName, otpLength);

export const makeSelectIsValidOTT = (formName, otpLength = 6) =>
  isValidOTTSelector(formName, otpLength);

export const makeSelectOttRequestId = () => requestOTT;

export const makeSelectOttExpiresIn = () => ottExpiresIn;

export const makeSelectOttResendAllowed = () => ottResendAllowed;

export const makeSelectOttResendAllowedAfter = () => ottResendAllowedAfter;

export const makeSelectGuestOttRequestId = () => guestRequestOTT;

export const makeSelectGuestOttExpiresIn = () => guestOttExpiresIn;

export const makeSelectGuestOttResendAllowed = () => guestOttResendAllowed;

export const makeSelectGuestOttResendAllowedAfter = () =>
  guestOttResendAllowedAfter;

export const makeSelectLoginSignupOttpExpiresIn = () =>
  loginSignupOttpExpiresIn;

export const makeSelectValidateGuestOtt = () => guestOttValidation;

export const makeSelectGuestOttFailureErrorCode = () => guestOttErrCode;

export const makeSelectUpdatedGuestToken = () => guestAccessToken;

export const makeSelectGuestOttChannels = () => guestOttChannelsSelector;
